import React from 'react';
import PropTypes from 'prop-types';
import { ExcoVideoWrapperAsync } from 'site-modules/shared/components/exco-video/exco-video-wrapper-async';

export function ExcoVideoViewerBlueBg({
  containerClasses = 'mb-2 pos-r mx-0_5 d-flex justify-content-center',
  containerStyles = null,
  maxWidth = '540px',
  aspectRatio = '16 / 9',
  offsetTop = '8px',
  offsetLeft = '8px',
}) {
  return (
    <div className={containerClasses} style={containerStyles}>
      <div className="pos-a w-100" style={{ aspectRatio, maxWidth }}>
        <div
          className="pos-a bg-blue-90 w-100 rounded-16"
          style={{ aspectRatio: 'inherit', top: `-${offsetTop}`, left: offsetLeft }}
        />
        <div
          className="pos-a bg-blue-80 w-100 rounded-16"
          style={{ aspectRatio: 'inherit', top: offsetTop, left: `-${offsetLeft}` }}
        />
      </div>
      <div style={{ aspectRatio, maxWidth }} className="w-100 rounded-12 overflow-hidden">
        <ExcoVideoWrapperAsync showTestText={false} />
      </div>
    </div>
  );
}

ExcoVideoViewerBlueBg.propTypes = {
  containerClasses: PropTypes.string,
  containerStyles: PropTypes.shape({}),
  maxWidth: PropTypes.string,
  aspectRatio: PropTypes.string,
  offsetTop: PropTypes.string,
  offsetLeft: PropTypes.string,
};
